import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table";
import Footer from "../../../Global/Footer/Footer";
import Header from "../../../Global/Header/Header";

export const TripBookingsView = (
  {bookingData}
) => {
  return (
    <>
      <div className={`w-full min-h-screen flex flex-col`}>
        <Header />
        <div className="min-h-[100vh] min-w-[100vw]">
          <div className="border shadow-sm rounded-lg my-[5vh] mx-[5%]">
            <Table>
              <TableHeader>
                <TableHead>
                  Name 
                </TableHead>
                <TableHead>
                  Email 
                </TableHead>
                <TableHead>
                  Phone 
                </TableHead>
                <TableHead>
                  Trip 
                </TableHead>
                <TableHead>
                  Amount 
                </TableHead>
                <TableHead>
                  TRN ID
                </TableHead>
                <TableHead>
                  Date
                </TableHead>
              </TableHeader>
              <TableBody>
                {
                  bookingData.length>0 && bookingData.map((booking,index) => (
                    <>
                    {booking.bookings.map((bk,index) => (
                      <TableRow key={index}>
                        <TableCell>{bk?.name}</TableCell>
                        <TableCell>{bk?.email}</TableCell>
                        <TableCell>{bk?.phone}</TableCell>
                        <TableCell>{bk?.tripName}</TableCell>
                        <TableCell>{bk?.transactionDetails?.data?.amount/100}</TableCell>
                        <TableCell>{bk?.transactionDetails?.data?.transactionId}</TableCell>
                        <TableCell>{bk?.createdAt?.constructor().slice(0,15)}</TableCell>
                      </TableRow>
                    ))}
                    </>
                  ))
                }
              </TableBody>
            </Table>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
